import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Helmet } from 'react-helmet';
import findIndex from 'ramda/src/findIndex';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import { convertUrl } from '~/services/util';

const Detail = ({ user, onLogin }) => {
    const authenticated = useSelector((state) => state.app.token);
    const loginUser = useSelector((state) => state.app.user?.community_user);
    const activeConnections = loginUser?.connections?.active_user_connections || [];
    const connected = findIndex((x) => x.connector?.user_id === user?.id, activeConnections) > -1 || loginUser?.id === user?.id;

    const handleConnect = () => {};

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <ErrorBoundary className="individual-profile-about">
            <Helmet>
                <title>
                    {user?.first_name || ''} {user?.last_name || ''}, Company Name, About
                </title>
                <meta name="description" content="Dealership Vendor Buyers Guide | DrivingSales" />
            </Helmet>
            <div className="d-flex d-flex ssm-column">
                <div className="d-flex-3 card me-2">
                    <p className="dsl-b24 bold mt-3 mt-md-0">About</p>
                    <p className="dsl-b16 mb-0 profile-about">{user?.profile?.info_bio}</p>
                </div>
                <div className="d-flex-2 card">
                    <p className="dsl-b24 bold mt-3 mt-md-0">Contact</p>
                    <div className="d-h-start py-3">
                        <p className="contact-label dsl-m12 mb-0">Phone</p>
                        {authenticated ? (
                            connected ? (
                                <p className="dsl-b16 mb-0">{user.profile?.contact_phone}</p>
                            ) : (
                                <Button name="Connect to view" type="link" onClick={handleConnect} />
                            )
                        ) : (
                            <p className="dsl-m16 mb-0">Private</p>
                        )}
                    </div>
                    <div className="d-h-start py-3">
                        <p className="contact-label dsl-m12 mb-0">Office</p>
                        {authenticated ? (
                            connected ? (
                                <p className="dsl-b16 mb-0">{user.profile?.office}</p>
                            ) : (
                                <Button name="Connect to view" type="link" onClick={handleConnect} />
                            )
                        ) : (
                            <p className="dsl-b16 mb-0">Private</p>
                        )}
                    </div>
                    <div className="d-h-start py-3">
                        <p className="contact-label dsl-m12 mb-0">Email</p>
                        {authenticated ? (
                            connected ? (
                                <p className="dsl-b16 mb-0">{user.profile?.contact_email || user?.email}</p>
                            ) : (
                                <Button name="Connect to view" type="link" onClick={handleConnect} />
                            )
                        ) : (
                            <p className="dsl-m16 mb-0">Private</p>
                        )}
                    </div>
                </div>
            </div>
            {!authenticated && (
                <div className="card">
                    <p className="dsl-b22 bold mt-3 mt-md-0">Experience</p>
                    <div className="d-flex profile-login text-center">
                        <p className="dsl-m16 mb-0">{`Log in to view ${user?.first_name}’s job experience, education, and blogs. You will also be able to connect and get in touch with them.`}</p>
                        <Button name="Login" className="mt-2" type="medium" onClick={() => onLogin()} />
                    </div>
                </div>
            )}
            {user?.profile?.experience && authenticated && (
                <div className="card">
                    <p className="dsl-b22 bold mt-3 mt-md-0">Experience</p>
                    {user.profile?.experience.map((item, index) => (
                        <Row className="mx-0 flex-column flex-md-row" key={`ex-${index}`}>
                            <Col xs={1} className="pl-0 pt-3">
                                <Avatar type="logo" url={convertUrl(item.logo, '/images/default_company.svg')} size="small" borderColor="#dee2e6" borderWidth={1} name={item.company} />
                            </Col>
                            <Col className="px-0" xs={11}>
                                <div className="d-h-start py-3">
                                    <p className="dsl-m12 mb-0 about-label">Company</p>
                                    <p className="dsl-b16 mb-0">{item.company}</p>
                                </div>
                                <div className="d-h-start py-3">
                                    <p className="dsl-m12 mb-0 about-label">Position</p>
                                    <p className="dsl-b16 mb-0">{item.position}</p>
                                </div>
                                <div className="d-h-start py-3">
                                    <p className="dsl-m12 mb-0 about-label">Dates of work</p>
                                    <p className="dsl-b16 mb-0">{item.date_span}</p>
                                </div>
                                <div className="d-h-start py-3">
                                    <p className="dsl-m12 mb-0 about-label">Description</p>
                                    <p className="dsl-b16 mb-0">{item.description}</p>
                                </div>
                            </Col>
                        </Row>
                    ))}
                </div>
            )}
            {user?.profile?.education && authenticated && (
                <div className="card">
                    <p className="dsl-b22 bold mt-3 mt-md-0">Education</p>
                    {user.profile?.education.map((item, index) => (
                        <div key={`ed-${index}`}>
                            <div className="d-h-start py-3">
                                <p className="dsl-m12 mb-0 about-label">University</p>
                                <p className="dsl-m16 mb-0">{item.school_name}</p>
                            </div>
                            <div className="d-h-start py-3">
                                <p className="dsl-m12 mb-0 about-label">Degree</p>
                                <p className="dsl-m16 mb-0">{item.degree}</p>
                            </div>
                            <div className="d-h-start py-3">
                                <p className="dsl-m12 mb-0 about-label">Graduation</p>
                                <p className="dsl-m16 mb-0">{item.graduation}</p>
                            </div>
                            <div className="d-h-start py-3">
                                <p className="dsl-m12 mb-0 about-label">Website</p>
                                <p className="dsl-m16 mb-0">{item.website}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {user?.profile?.accolades && authenticated && (
                <div className="card">
                    <p className="dsl-b22 bold mt-3 mt-md-0">Accolades/Awards</p>
                    {user.profile?.accolades.map((item, index) => (
                        <div key={`ac-${index}`}>
                            <div className="d-h-start py-3">
                                <p className="dsl-m12 mb-0 about-label">Title</p>
                                <p className="dsl-m16 mb-0">{item.title}</p>
                            </div>
                            <div className="d-h-start py-3">
                                <p className="dsl-m12 mb-0 about-label">Company/place</p>
                                <p className="dsl-m16 mb-0">{item.company}</p>
                            </div>
                            <div className="d-h-start py-3">
                                <p className="dsl-m12 mb-0 about-label">Date</p>
                                <p className="dsl-m16 mb-0">{item.date}</p>
                            </div>
                            <div className="d-h-start py-3">
                                <p className="dsl-m12 mb-0 about-label">Description</p>
                                <p className="dsl-m16 mb-0">{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </ErrorBoundary>
    );
};

export default Detail;
